import * as React from 'react';
import {View, StyleSheet, Platform} from 'react-native';
import {useStyles} from '../../hooks/styles';
import {Props} from './model';
import {images} from '../../../assets/icons';
import {useNavigation} from '@react-navigation/native';
import {Link} from '../link';
import {Text} from '../text';
import {Screens} from '../../routing';

export default ({routes, style, ...restProps}: Props) => {
  const styles = useComponentStyles();
  const nav = useNavigation();

  // Wrap navigate to handle nested navigation on mobile
  const navigate = React.useCallback(
    (screen: string, params?: any) => {
      if (Platform.OS === 'web') {
        // Desktop - flat navigation
        (nav.navigate as any)(screen, params);
      } else {
        // Mobile - navigate through MainTabs
        (nav.navigate as any)(Screens.MainTabs, {
          screen: Screens.CardServicesMenu,
          params: {screen, ...params},
        });
      }
    },
    [nav],
  );

  return (
    <View style={[styles.container, style]} {...restProps}>
      {routes.map((route, index) => {
        const isLast = index === routes.length - 1;

        return (
          <React.Fragment key={route.routeName}>
            {isLast ? (
              <Text
                testID={`breadcrumb-item-${route.routeName}-link-id`}
                style={[styles.text, styles.textActive]}
                ellipsizeMode='clip'
                numberOfLines={1}>
                {route.title}
              </Text>
            ) : (
              <Link testID={`breadcrumb-item-${route.routeName}-link-id`} screen={route.routeName} navigate={navigate}>
                <Text style={styles.text} numberOfLines={1}>
                  {route.title}
                </Text>
              </Link>
            )}
            {!isLast ? (
              <View style={styles.separator}>
                <images.ChevronRight color={StyleSheet.flatten(styles.icon).color} />
              </View>
            ) : null}
          </React.Fragment>
        );
      })}
    </View>
  );
};

const useComponentStyles = () =>
  useStyles(({theme}) => ({
    container: {
      flexGrow: 0,
      flexBasis: 'auto',
      flexShrink: 0,
      flexDirection: 'row',
      alignItems: 'center',
    },
    text: {
      ...theme.fonts.bodySmallLight,
      maxWidth: 430,
      overflow: 'hidden',
    },
    textActive: theme.fonts.bodySmallLight,
    separator: {
      width: 16,
      height: 16,
      marginHorizontal: 6,
    },
    icon: {
      color: theme.color.textColor,
    },
  }));
